import { Box, Typography } from "@mui/material";
import AngebotSlot from "../angebot/AngebotSlot";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import { useTheme } from "@mui/material/styles";

export default function JobSlots({ leitungSlots, teamSlots, onReserve }) {
  const { isMobile } = useAppContext();
  const theme = useTheme();
  /**
   * =========================================================
   * ✅ MOBILE LAYOUT (STACKED)
   * =========================================================
   */
  if (isMobile) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2, // ✅ vertical separation between sections
        }}
      >
        {/* ✅ LEITUNG */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              color: theme.palette.text.secondary,
              mt: 1,
            }}
          >
            Lehrpersonen
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            {leitungSlots.map((angebot) => (
              <AngebotSlot
                key={angebot.id}
                angebot={angebot}
                onReserve={onReserve}
              />
            ))}
          </Box>
        </Box>

        {/* ✅ TEAM */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              color: theme.palette.text.secondary,
              mt: 1,
            }}
          >
            Lernende
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              rowGap: 1.2,
            }}
          >
            {teamSlots.map((angebot) => (
              <AngebotSlot
                key={angebot.id}
                angebot={angebot}
                onReserve={onReserve}
              />
            ))}
          </Box>
        </Box>
      </Box>
    );
  }

  /**
   * =========================================================
   * ✅ DESKTOP LAYOUT (SIDE-BY-SIDE)
   * =========================================================
   */
  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
        alignItems: "flex-start",
      }}
    >
      {/* ✅ LEITUNG */}
      <Box
        sx={{
          minWidth: 110,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          pr: 2,
          borderRight: (theme) => `2px solid ${theme.palette.divider}`,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.secondary,
            mt: 1,
          }}
        >
          Lehrpersonen
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {leitungSlots.map((angebot) => (
            <AngebotSlot
              key={angebot.id}
              angebot={angebot}
              onReserve={onReserve}
            />
          ))}
        </Box>
      </Box>

      {/* ✅ TEAM */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.secondary,
            mt: 1,
          }}
        >
          Lernende
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1.2,
            rowGap: 1.2,
          }}
        >
          {teamSlots.map((angebot) => (
            <AngebotSlot
              key={angebot.id}
              angebot={angebot}
              onReserve={onReserve}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
